import styled from 'styled-components';

import {
  SkeletonBodyCopy,
  SkeletonButton as BaseSkeletonButton,
  SkeletonCard,
  SkeletonRectangle,
} from '@xing-com/skeleton';
import { scale130, scale190, scale250, spaceL } from '@xing-com/tokens';

const SkeletonWrapper = styled(SkeletonCard)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spaceL};
`;

const SkeletonButton = styled(BaseSkeletonButton)`
  width: ${scale250};
`;

export const ExperimentalMatchingSkillsSkeleton: React.FC = () => (
  <SkeletonWrapper>
    <SkeletonRectangle height={scale130} width={scale190} />
    <SkeletonBodyCopy amountRows={3} />
    <SkeletonButton />
  </SkeletonWrapper>
);
